"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1025],{

/***/ 62659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "en": function() { return /* reexport default export from named module */ _en_json__WEBPACK_IMPORTED_MODULE_0__; },
/* harmony export */   "es": function() { return /* reexport default export from named module */ _es_json__WEBPACK_IMPORTED_MODULE_1__; }
/* harmony export */ });
/* harmony import */ var _en_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64798);
/* harmony import */ var _es_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89890);




/***/ }),

/***/ 61025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LegacyApp; },
  "getStaticProps": function() { return /* binding */ getStaticProps; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js + 1 modules
var emotion_element_f0de968e_browser_esm = __webpack_require__(20442);
// EXTERNAL MODULE: ./node_modules/@mui/material/CssBaseline/CssBaseline.js
var CssBaseline = __webpack_require__(66720);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/queryClient.mjs + 3 modules
var queryClient = __webpack_require__(51767);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/Hydrate.mjs + 1 modules
var Hydrate = __webpack_require__(80910);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query-devtools/build/lib/index.mjs
var lib = __webpack_require__(90041);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(95627);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/font-loader/index.tsx



var isApplePlatform = ['iPhone', 'iPod', 'iPad', 'iPhone Simulator', 'iPod Simulator', 'iPad Simulator', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'Pike v7.6 release 92', 'Pike v7.8 release 517'];

function FontLoader() {
  var os =  true ? window.navigator.platform : 0;
  if (os == null) return null;

  if (isApplePlatform.includes(os)) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(MacGlobalStyles, null);
  } else {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null);
  }
}

/* harmony default export */ var font_loader = (FontLoader);

function MacGlobalStyles() {
  return (0,emotion_react_browser_esm/* jsx */.tZ)((style_default()), {
    id: "2940328930"
  }, [":root{--font-family:\"Gotham-mac\" !important;}"]);
}
// EXTERNAL MODULE: ./shared/components/layout/index.tsx + 17 modules
var layout = __webpack_require__(79709);
// EXTERNAL MODULE: ./styles/theme/theme.tsx
var theme = __webpack_require__(6412);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(50841);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 8 modules
var redux_toolkit_esm = __webpack_require__(66741);
// EXTERNAL MODULE: ./store/feature/auth/auth-dialog.slice.ts
var auth_dialog_slice = __webpack_require__(54540);
// EXTERNAL MODULE: ./store/feature/auth/auth.slice.ts
var auth_slice = __webpack_require__(42550);
// EXTERNAL MODULE: ./store/property-detail/index.tsx
var property_detail = __webpack_require__(78595);
// EXTERNAL MODULE: ./store/properties-loading/index.tsx
var properties_loading = __webpack_require__(9056);
;// CONCATENATED MODULE: ./store/index.ts





var store = (0,redux_toolkit_esm/* configureStore */.xC)({
  reducer: {
    Auth: auth_slice/* default */.ZP,
    AuthDialog: auth_dialog_slice/* default */.ZP,
    propertyDetail: property_detail/* default */.ZP,
    propertiesLoading: properties_loading/* default */.ZP
  }
});
// EXTERNAL MODULE: ./shared/context/news.context.tsx
var news_context = __webpack_require__(30995);
// EXTERNAL MODULE: ./shared/components/enviroment-protect/LayoutProtect.tsx + 3 modules
var LayoutProtect = __webpack_require__(85229);
// EXTERNAL MODULE: ./lang/index.ts
var lang = __webpack_require__(62659);
// EXTERNAL MODULE: ./shared/models/functions/removeparams.ts
var removeparams = __webpack_require__(57626);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CheckCircleOutline.js
var CheckCircleOutline = __webpack_require__(18037);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/HighlightOff.js
var HighlightOff = __webpack_require__(53592);
// EXTERNAL MODULE: ./node_modules/@mui/material/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(84808);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 3 modules
var Modal = __webpack_require__(39043);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
;// CONCATENATED MODULE: ./shared/context/ModalAlert.context.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var ModalContext = /*#__PURE__*/(0,react.createContext)(undefined);
var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(null),
      modalContent = _useState[0],
      setModalContent = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var openModal = function openModal(content) {
    setModalContent(content);
    setIsOpen(true);
  };

  var closeModal = function closeModal() {
    setIsOpen(false);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(ModalContext.Provider, {
    value: {
      openModal: openModal,
      closeModal: closeModal
    }
  }, children, modalContent && (0,emotion_react_browser_esm/* jsx */.tZ)(ModalMessage, (0,esm_extends/* default */.Z)({}, modalContent, {
    open: isOpen,
    handleClose: closeModal
  })));
};
var useModal = function useModal() {
  var context = useContext(ModalContext);

  if (!context) {
    console.error("useModal must be used within a ModalProvider");
  }

  return context;
};










var ModalMessage = function ModalMessage(_ref2) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "success" : _ref2$variant,
      open = _ref2.open,
      handleClose = _ref2.handleClose,
      title = _ref2.title,
      body = _ref2.body,
      buttonText = _ref2.buttonText;
  var translation = (0,next_intl_cjs_production_min.useTranslations)("alerts");

  var handleForceClose = function handleForceClose() {
    handleClose();
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)(ModalCustom, {
    "aria-labelledby": "transition-modal-title",
    "aria-describedby": "transition-modal-description",
    open: open,
    closeAfterTransition: true,
    BackdropComponent: Backdrop/* default */.Z,
    BackdropProps: {
      timeout: 500
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Fade/* default */.Z, {
    "in": open
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: ModalAlert_context_style
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ModalCloseButton, {
    onClick: handleForceClose
  }, "Cerrar"), variant === "success" ? (0,emotion_react_browser_esm/* jsx */.tZ)(IconSuccess, null) : variant === "error" ? (0,emotion_react_browser_esm/* jsx */.tZ)(IconError, null) : null, (0,emotion_react_browser_esm/* jsx */.tZ)(Title, null, title), (0,emotion_react_browser_esm/* jsx */.tZ)(Body, null, body), (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    onClick: handleClose
  }, buttonText !== null && buttonText !== void 0 ? buttonText : "Ok"))))));
};

/* harmony default export */ var ModalAlert_context = ((/* unused pure expression or super */ null && (ModalMessage)));
var ModalAlert_context_style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 4
};

var ModalCustom = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Modal/* default */.Z,  true ? {
  target: "epruug66"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    "& .MuiBox-root": {
      backgroundColor: "#EFEFF1",
      borderRadius: "20px",
      border: "0px"
    }
  };
},  true ? "" : 0);

var IconSuccess = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CheckCircleOutline/* default */.Z,  true ? {
  target: "epruug65"
} : 0)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: "var(--color-brand-green-main)",
    margin: "auto",
    width: 80,
    height: 80,
    textAlign: "center",
    display: "block",
    marginBottom: 20
  };
},  true ? "" : 0);

var IconError = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(HighlightOff/* default */.Z,  true ? {
  target: "epruug64"
} : 0)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    color: "var(--color-brand-red-secondary)",
    margin: "auto",
    width: 80,
    height: 80,
    textAlign: "center",
    display: "block",
    marginBottom: 20
  };
},  true ? "" : 0);

var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h5",  true ? {
  target: "epruug63"
} : 0)( true ? {
  name: "3vhpnn",
  styles: "font-size:16px;color:var(--color-brand-blue-main);text-align:center;display:block;margin:20px 0px"
} : 0);

var Body = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h5",  true ? {
  target: "epruug62"
} : 0)( true ? {
  name: "9urtb4",
  styles: "font-size:13px;color:var(--color-brand-grey-main);text-align:center"
} : 0);

var ContainerButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h5",  true ? {
  target: "epruug61"
} : 0)( true ? {
  name: "dgxrvq",
  styles: "display:flex;justify-content:center;align-items:center;margin:20px 0px"
} : 0);

var ModalCloseButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Box/* default */.Z,  true ? {
  target: "epruug60"
} : 0)( true ? {
  name: "1d2d3ja",
  styles: "width:100%;display:flex;justify-content:flex-end;font-weight:600;color:var(--color-brand-grey-main);cursor:pointer"
} : 0);
;// CONCATENATED MODULE: ./shared/components/LegacyApp.tsx























function getStaticProps(_x) {
  return _getStaticProps.apply(this, arguments);
}

function _getStaticProps() {
  _getStaticProps = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var locale, preview;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            locale = _ref.locale, preview = _ref.preview;
            return _context.abrupt("return", {
              props: {
                messages: locale === "es" ? lang.es : lang.en
              }
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getStaticProps.apply(this, arguments);
}

var LegacyApp_queryClient = new queryClient/* QueryClient */.S({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

function storePathValues() {
  var storage = globalThis === null || globalThis === void 0 ? void 0 : globalThis.sessionStorage;
  if (!storage) return;

  if (storage.getItem("currentPath") != globalThis.location.pathname) {
    var prevPath = storage.getItem("currentPath");
    storage.setItem("prevPath", prevPath || "");
  }

  storage.setItem("currentPath", globalThis.location.pathname);
}

function handleIdiomLoader(router) {
  var loaderIdiom = localStorage.getItem("idiom");

  if (loaderIdiom && loaderIdiom !== router.locale) {
    router.replace(router.asPath, router.asPath, {
      locale: loaderIdiom.toLowerCase()
    })["catch"](function (err) {
      // Ignore the "Cancel rendering route" error thrown when the navigation is interrupted.
      if (err !== null && err !== void 0 && err.cancelled) return;
      console.error("[handleIdiomLoader] Failed to change locale", err);
    });
  }
}

function MyApp(props) {
  var Component = props.Component,
      pageProps = props.pageProps;
  var router = (0,next_router.useRouter)();
  var Layout = Component.Layout || react.Fragment;
  var locate = router.locale === "es" ? lang.es : lang.en;
  (0,react.useEffect)(function () {
    storePathValues();
  }, [router.asPath]);
  (0,react.useEffect)(function () {
    handleIdiomLoader(router);
  }, []);

  var appContent = (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
    reCaptchaKey: "6Lf33YsrAAAAABXoJncHE60n-M14RaC_opEPEffc" || 0
  }, (0,emotion_react_browser_esm/* jsx */.tZ)((head_default()), null, (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    key: "viewport",
    name: "viewport",
    content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("link", {
    rel: "canonical",
    href: (0,removeparams/* default */.Z)(router.asPath),
    key: "canonical"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(font_loader, null), (0,emotion_react_browser_esm/* jsx */.tZ)(next_intl_cjs_production_min.NextIntlProvider, {
    messages: locate
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(emotion_element_f0de968e_browser_esm.a, {
    theme: theme/* default */.Z
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ModalProvider, null, (0,emotion_react_browser_esm/* jsx */.tZ)(notistack_esm/* SnackbarProvider */.wT, {
    maxSnack: 3
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(CssBaseline/* default */.ZP, null), (0,emotion_react_browser_esm/* jsx */.tZ)(QueryClientProvider/* QueryClientProvider */.aH, {
    client: LegacyApp_queryClient
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Hydrate/* Hydrate */.p, {
    state: pageProps.dehydratedState
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(es/* Provider */.zt, {
    store: store
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(news_context/* default */.Z, null, (0,emotion_react_browser_esm/* jsx */.tZ)(layout/* default */.Z, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Layout, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Component, pageProps)))))), (0,emotion_react_browser_esm/* jsx */.tZ)(lib/* ReactQueryDevtools */.t, {
    initialIsOpen: false
  }))))))));

  return (0,emotion_react_browser_esm/* jsx */.tZ)(LayoutProtect/* default */.Z, null, appContent);
}

/* harmony default export */ var LegacyApp = (MyApp);

/***/ }),

/***/ 57626:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Creates a canonical URL by removing unnecessary query parameters
 * @param url - The original URL
 * @param keepParams - Optional array of parameter names to keep
 * @returns A clean canonical URL
 */
var prepareUrl = function prepareUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  try {
    // Handle empty or invalid URLs
    if (!url || typeof url !== "string") return ""; // For relative URLs, prepend with origin

    var isRelative = !url.startsWith("http");
    var baseUrl =  true ? window.location.origin : 0;
    var fullUrl = isRelative ? "".concat(baseUrl).concat(url.startsWith("/") ? "" : "/").concat(url) : url; // Parse the URL

    var urlObject = new URL(fullUrl); // If no params to keep, return without query string

    if (!keepParams.length) {
      return "".concat(urlObject.origin).concat(urlObject.pathname);
    } // Create a new URLSearchParams object to manipulate parameters


    var params = new URLSearchParams(); // Only keep specified parameters

    keepParams.forEach(function (param) {
      var value = urlObject.searchParams.get(param);

      if (value) {
        params.set(param, value);
      }
    }); // Build the canonical URL

    var queryString = params.toString();
    return "".concat(urlObject.origin).concat(urlObject.pathname).concat(queryString ? "?".concat(queryString) : "");
  } catch (error) {
    // Fallback method
    try {
      var questionMarkIndex = url.indexOf("?");

      if (questionMarkIndex === -1 || !keepParams.length) {
        // No query params or nothing to keep
        return questionMarkIndex === -1 ? url : url.substring(0, questionMarkIndex);
      } // Manual parsing for fallback


      var base = url.substring(0, questionMarkIndex);
      var query = url.substring(questionMarkIndex + 1);
      var pairs = query.split("&");
      var filteredPairs = pairs.filter(function (pair) {
        var key = pair.split("=")[0];
        return keepParams.includes(key);
      });
      return filteredPairs.length > 0 ? "".concat(base, "?").concat(filteredPairs.join("&")) : base;
    } catch (_unused) {
      return url; // Return original if all else fails
    }
  }
};

var createCanonicalUrl = function createCanonicalUrl(url) {
  var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var urlresolve = prepareUrl(url, keepParams); // console.log(urlresolve);

  return urlresolve;
};

/* harmony default export */ __webpack_exports__["Z"] = (createCanonicalUrl);

/***/ }),

/***/ 9056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dg": function() { return /* binding */ usePropertiesLoading; }
/* harmony export */ });
/* unused harmony exports setPropertiesLoading, clearPropertiesLoading */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66741);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);


var initialState = false;
var PropertiesLoadingSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
  name: "propertiesLoading",
  initialState: initialState,
  reducers: {
    setPropertiesLoading: function setPropertiesLoading(state, action) {
      return action.payload;
    },
    clearPropertiesLoading: function clearPropertiesLoading() {
      return false;
    }
  }
});
var _PropertiesLoadingSli = PropertiesLoadingSlice.actions,
    setPropertiesLoading = _PropertiesLoadingSli.setPropertiesLoading,
    clearPropertiesLoading = _PropertiesLoadingSli.clearPropertiesLoading;

/* harmony default export */ __webpack_exports__["ZP"] = (PropertiesLoadingSlice.reducer); // hook

var usePropertiesLoading = function usePropertiesLoading() {
  var loadingRequest = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function (state) {
    return state === null || state === void 0 ? void 0 : state.propertiesLoading;
  });
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();

  var setLoadingPropertyAction = function setLoadingPropertyAction(state) {
    dispatch(setPropertiesLoading(state));
  };

  var clearPropertyAction = function clearPropertyAction() {
    dispatch(clearPropertiesLoading());
  };

  return {
    loadingRequest: loadingRequest,
    clearPropertyAction: clearPropertyAction,
    setLoadingPropertyAction: setLoadingPropertyAction
  };
};

/***/ }),

/***/ 78595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qd": function() { return /* binding */ usePropertyDetail; }
/* harmony export */ });
/* unused harmony exports setPropertyDetail, clearPropertyDetail */
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66741);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var initialState = {};
var PropertyDetailSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSlice */ .oM)({
  name: "propertyDetail",
  initialState: initialState,
  reducers: {
    setPropertyDetail: function setPropertyDetail(state, action) {
      return _objectSpread(_objectSpread({}, state), action.payload);
    },
    clearPropertyDetail: function clearPropertyDetail() {}
  }
});
var _PropertyDetailSlice$ = PropertyDetailSlice.actions,
    setPropertyDetail = _PropertyDetailSlice$.setPropertyDetail,
    clearPropertyDetail = _PropertyDetailSlice$.clearPropertyDetail;

/* harmony default export */ __webpack_exports__["ZP"] = (PropertyDetailSlice.reducer); // hook

var usePropertyDetail = function usePropertyDetail() {
  var property = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function (state) {
    return state === null || state === void 0 ? void 0 : state.propertyDetail;
  });
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();

  var setDetailPropertyAction = function setDetailPropertyAction(detail) {
    dispatch(setPropertyDetail(detail));
  };

  var clearPropertyAction = function clearPropertyAction() {
    dispatch(clearPropertyDetail());
  };

  return {
    property: property,
    setDetailPropertyAction: setDetailPropertyAction,
    clearPropertyAction: clearPropertyAction
  };
};

/***/ }),

/***/ 6412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(549);

var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
  typography: {
    fontFamily: "var(--font-family)"
  },
  palette: {
    primary: {
      main: "#1f3564" //blue remax

    }
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (theme);

/***/ })

}]);